import { render, staticRenderFns } from "./Puzzles.vue?vue&type=template&id=2fb00f4c&scoped=true&"
import script from "./Puzzles.vue?vue&type=script&lang=js&"
export * from "./Puzzles.vue?vue&type=script&lang=js&"
import style0 from "./Puzzles.vue?vue&type=style&index=0&id=2fb00f4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb00f4c",
  null
  
)

export default component.exports